import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";

import * as _ from "lodash";
import * as angular from "angular";

import { ContactService } from "../services/contact-service";
import { NotifyService } from "../services/notify-service";
import { EventService } from "../services/event-service";
import { EntityService } from "../services/entity-service";
import { IdentityService } from "../services/identity-service";
import { AclService } from "../services/acl-service";
import { EntityConfigService } from "../services/entity-config-service";
import { ContactSharedDataService } from "../services/contact-shared-data-service";
import { BaseAssociationController } from "../controllers/base-associations-controller";
import { BaseEntityAssociationController } from "./rlAdmin.controllers";
import { AdminService } from "../services/admin-service";
import { SearchService } from "../services/search-service";

export class ContactSecurityController {

    static $inject = ["$scope", "$q", "$window", "entityService", "contactService", "notifyService", "eventService", "identityService", "aclService"];

    enabled: boolean;
    initialized: boolean;
    contactID: string;
    entityRecord: Models.IEntity;
    visibility: number;
    canEdit: boolean;
    locked: boolean;

    constructor(private $scope: ng.IScope, private $q: ng.IQService, private $window: ng.IWindowService, private entityService: EntityService,
        private contactService: ContactService, private notifyService: NotifyService, private eventService: EventService, private identityService: IdentityService,
        private aclService: AclService) {

        this.contactID = "";
        this.entityRecord = null;
        this.initialized = false;
        this.visibility = 1;
        this.canEdit = false;
        this.locked = false;

        $scope.$watch(() => {
            if (this.contactID == null) {
                return null;
            } else {
                return this.contactID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        this.Init(this.contactID);
                    });
                }
            });
    }

    Init(contactID: string) {
        this.contactID = contactID;
        this.notifyService.startProgress();

        var promise1 = this.aclService.loadActivityAcls()
            .then((acls) => {
                switch (Consts.CharTypeIDs.user) {
                    case Consts.CharTypeIDs.user:
                        this.canEdit = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod2);
                        break;
                }
            });

        var promise2 = this.entityService.getEntity(this.contactID)
            .then((result) => {
                this.entityRecord = result.record;
                if (result.charDataCollection != null) {
                    if (result.charDataCollection.status.lockIndicator == 0) {
                        this.locked = false;
                    }
                    else {
                        this.locked = true;
                    }
                }
            });

        this.$q.all([promise1, promise2])
            .then(() => {
                this.initialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Contact?") && this.$window.confirm("Are you REALLY SURE you want to delete this Contact?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.entityRecord.id)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ContactListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Contact");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    RefreshAll(): ng.IPromise<any> {
        this.notifyService.startProgress();
        var promise5 = this.entityService.getEntityRecord(this.contactID).then((result) => this.entityRecord = result);
        return this.$q.all([promise5])
            .then(() => {
                return this.RefreshValidation();
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }
}

export class ContactCreateController {
    static $inject = ["$scope", "$window", "$q", "$timeout", "entityService", "notifyService", "contactService", "entityConfigService", "identityService", "aclService"];

    divisionID: number;
    charTypeID: number;
    templateID: number;
    successUrl: string;
    cancelUrl: string;
    editMode: boolean;
    visibility: number;
    saving: boolean;
    entityCharDataCollection: Models.ICharDataCollection;

    isNewAssociation: boolean;
    associateToParentEntityID: string;
    isParentAssociation: boolean;

    //Contact Specific
    appUrls: Models.IApplicationInfo[];
    roles: Models.IAccountRole[];
    // groups: Models.IAccountGroup[];
    templates: Models.ICharacteristicTemplate[];
    identityRoles: Models.IAspNetUserRole[];
    selectedIdentityRoles: Models.IAspNetUserRole[];
    initialized: boolean;
    filteredAppUrls: Models.IApplicationInfo[];
    isMembership: boolean;
    showApplications: boolean;
    showRoles: boolean;
    //showGroups: boolean;
    selectedAppUrls: { [key: string]: boolean };
    selectedAppUrlIDs: number[];
    selectedRoles: { [key: string]: boolean };
    selectedRoleIDs: number[];
    // selectedGroups: { [key: string]: boolean };
    //selectedGroupIDs: number[];
    password: string;
    confirmPassword: string;
    passwordValidators: { [key: string]: (value: string) => boolean };
    confirmPasswordValidators: { [key: string]: (value: string) => boolean };
    hasLength: boolean;
    hasNumber: boolean;
    hasUpper: boolean;
    hasLower: boolean;
    hasSymbol: boolean;
    hasGoodPassword: boolean;
    isPasswordRequired: boolean;

    canCreate: boolean = false;
    canEdit: boolean = false;

    constructor(
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private entityService: EntityService,
        private notifyService: NotifyService,
        private contactService: ContactService,
        private entityConfigService: EntityConfigService,
        private identityService: IdentityService,
        private aclService: AclService
    ) {
        this.divisionID = 0;
        this.charTypeID = -1;
        this.templateID = -1;
        this.successUrl = "";
        this.cancelUrl = "";
        this.editMode = true;
        this.visibility = 1;
        this.entityCharDataCollection = null;
        this.saving = false;

        //Contact Specific
        this.initialized = false;
        this.templates = [];

        this.appUrls = [];
        this.filteredAppUrls = [];
        this.selectedAppUrls = {};
        this.selectedAppUrlIDs = [];

        this.roles = [];
        this.selectedRoles = {};
        this.selectedRoleIDs = [];
        this.identityRoles = [];
        this.selectedIdentityRoles = [];

        //this.groups = [];
        //this.selectedGroups = {};
        //this.selectedGroupIDs = [];

        this.isMembership = false;
        this.showApplications = false;
        this.showRoles = false;
        //this.showGroups = false;
        this.password = "";
        this.confirmPassword = "";
        this.isPasswordRequired = false;

        $scope.$watch(() => this.templateID, (newValue, oldValue) => {
            if (newValue != oldValue) {
                this.GetTemplate();
            }
        });

        var getIds = (target: { [key: string]: boolean }) => {
            return _(target)
                .pairs()
                .filter((pair) => { return pair[1] === true; })
                .map((pair) => { return _.parseInt(<string>pair[0]); })
                .valueOf();
        };

        $scope.$watch(() => this.selectedAppUrls,
            (newValue: { [key: string]: boolean }, oldValue: { [key: string]: boolean }) => {
                if (newValue != oldValue) {
                    this.selectedAppUrlIDs = getIds(newValue);
                }
            }, true);

        $scope.$watch(() => this.selectedRoles,
            (newValue: { [key: string]: boolean }, oldValue: { [key: string]: boolean }) => {
                if (newValue != oldValue) {
                    this.selectedRoleIDs = getIds(newValue);
                }
            }, true);

        //$scope.$watch(() => this.selectedGroups,
        //    (newValue: { [key: string]: boolean }, oldValue: { [key: string]: boolean }) => {
        //        if (newValue != oldValue) {
        //            this.selectedGroupIDs = getIds(newValue);
        //        }
        //    }, true);

        var validationWatchFunc = () => { return [this.templateID, this.selectedAppUrlIDs, this.isMembership]; };
        var validationUpdateFunc = (newValue, oldValue) => {
            var template: Models.ICharacteristicTemplate = newValue[0];
            var selectedAppUrlIDs: number[] = newValue[1];
            var isMembership: boolean = newValue[2];

            if (isMembership) {
                this.showApplications = template != null;
                this.showRoles = _.any(selectedAppUrlIDs);
                //this.showGroups = _(this.appUrls)
                //    .filter((appUrl) => { return _.contains(selectedAppUrlIDs, appUrl.appUrlID); })
                //    .some((appUrl) => { return appUrl.urlTypeID == 3; });
            } else {
                this.showApplications = false;
                this.showRoles = false;
                //this.showGroups = false;
            }
        };

        $scope.$watch(validationWatchFunc, validationUpdateFunc, true);

        this.hasLength = false;
        this.hasNumber = false;
        this.hasUpper = false;
        this.hasLower = false;
        this.hasSymbol = false;
        this.hasGoodPassword = false;
        this.passwordValidators = {
            "format": (newValue) => {
                var value = newValue || "";
                this.hasLength = value.length >= 8;
                this.hasNumber = /[0-9]/.test(value);
                this.hasLower = /[a-z]/.test(value);
                this.hasUpper = /[A-Z]/.test(value);
                this.hasSymbol = /[^0-9a-zA-Z]/.test(value);
                this.hasGoodPassword = this.hasLength && this.hasLower && this.hasNumber && this.hasSymbol && this.hasUpper;
                return _.isEmpty(value) || !this.isMembership || this.hasGoodPassword;
            }

        };
        this.confirmPasswordValidators = {
            "mismatch": (newValue) => {
                return !this.isMembership || angular.equals(newValue, this.password);
            }
        };

        this.$scope.$watchGroup([() => this.isMembership, () => this.selectedAppUrlIDs],
            (newValue, oldValue) => {
                this.isPasswordRequired = this.isMembership && this.selectedAppUrlIDs.length > 0;
            });
    }

    Init(charTypeID: number, templateID: number, successUrl: string, cancelUrl: string, templateGroupIDs: number[], isNewAssociation?: boolean, associateToParentEntityID?: string, isParentAssociation?: boolean) {
        this.charTypeID = charTypeID;
        this.successUrl = successUrl;
        this.cancelUrl = cancelUrl;
        this.templateID = templateID;

        this.isNewAssociation = isNewAssociation;
        this.associateToParentEntityID = associateToParentEntityID;
        this.isParentAssociation = isParentAssociation;

        //Get ACLs for user
        // TODO: Why does this pass -1 sometimes
        if (this.associateToParentEntityID != "-1") {
            this.entityService.getEntityRecord(this.associateToParentEntityID)
                .then((result) => {
                    var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
                    this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
                    this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
                });
        }

        var promise1 = this.contactService.getApplicationList()
            .then((result) => {
                this.appUrls = result;
            });

        var promise2 = this.contactService.getUserRoles()
            .then((result) => {
                this.roles = result;
            });

        //var promise3 = this.contactService.getUserGroups()
        //    .then((result) => {
        //    this.groups = result;
        //});

        var promise4 = this.entityConfigService.getCharacteristicTemplates(this.charTypeID)
            .then((result) => {
                this.templates = result.filter(ct => Utils.AclUtil.hasCreateAccess(this.aclService.acls, ct.acl));
                //this.selectedTemplate = _.find<Models.ICharacteristicTemplate>(this.templates,(template) => template.templateID == templateID);
            });

        var promise5 = this.identityService.getRoleList().then((result) => this.identityRoles = result);

        this.$q.all([promise1, promise2, promise4, promise5])
            .then(() => {
                this.initialized = true;
                this.GetTemplate();
            });
    }

    GetTemplate() {
        if (this.templateID > 0) {
            this.notifyService.startProgress();
            var templateID = Utils.IdBuilder.buildTemplateID(this.divisionID, this.charTypeID, this.templateID);
            this.entityService.getEmptyEntityCharData(templateID)
                .then((result) => {
                    this.entityCharDataCollection = result;

                    //Contact Specific
                    var currentTemplate = _.find(this.templates, t => t.templateID == this.templateID);

                    if (currentTemplate.templateGroupID == 1) {
                        this.filteredAppUrls = _.filter<Models.IApplicationInfo>(this.appUrls, (appUrl) => { return appUrl.urlTypeID == 1; });
                    } else if (currentTemplate.templateGroupID == 2) {
                        this.filteredAppUrls = _.filter<Models.IApplicationInfo>(this.appUrls, (appUrl) => { return appUrl.urlTypeID == 1 || appUrl.urlTypeID == 3; });
                    }

                    //need a better approach for users that can log in vs those that can't, currently using existence of email combined with not being an address book contact: template 5 of the external template group
                    this.isMembership = _.any<Models.ICharacteristicMetaData>(this.entityCharDataCollection.templateMetaData.characteristicMetaDatas, (cmd) => { return cmd.tagLabel == "email"; })
                        && !(this.templateID == 5 && currentTemplate.templateGroupID == 1);

                    this.showApplications = false;
                    this.showRoles = false;
                    //this.showGroups = false;

                    this.selectedRoles = {};
                    this.selectedAppUrls = {};
                    // this.selectedGroups = {};

                }).finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    SaveEntity() {
        if (!this.saving) {
            this.saving = true;
            this.notifyService.startProgress();
            var templateID = Utils.IdBuilder.buildTemplateID(this.divisionID, this.charTypeID, this.templateID);
            var identityRoleIDs = this.selectedIdentityRoles.map((role) => role.roleID);

            return this.contactService.createContact(templateID, this.entityCharDataCollection.charDatas, this.selectedAppUrlIDs, this.selectedRoleIDs, null, identityRoleIDs, this.password)
                .then((result) => {
                    if (result.success) {
                        //If the user does not have Write access, then redirect them to the newly created entity, NOT the Contacts Association page
                        if (!this.canEdit) {
                            var entityUrl = "/Go/" + result.entityID;
                            this.editMode = false;
                            this.$timeout(() => {
                                this.$window.location.assign(entityUrl);
                            });
                        }
                        else {
                            if (this.isNewAssociation) {
                                var recID = Utils.IdBuilder.splitEntityID(this.associateToParentEntityID).recID;
                                this.successUrl = this.successUrl.replace("-1", recID.toString());
                                //Associate the deal to the parent entity id
                                this.DoAssociation(result.entityID);
                            }
                            else {
                                var recID = Utils.IdBuilder.splitEntityID(result.entityID).recID;
                                this.successUrl = this.successUrl.replace("-1", recID.toString());
                            }

                            this.editMode = false;
                            this.$timeout(() => {
                                this.$window.location.assign(this.successUrl);
                            });
                        }
                    } else {
                        this.notifyService.notifyError("There was an error creating your entity.");
                    }
                }, () => {
                    this.saving = false;
                    this.notifyService.notifyError("There was an error creating your entity.");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    DoAssociation(newEntityID: string) {
        this.notifyService.startProgress();

        var childEntityIDs: string[] = [];

        childEntityIDs.push(newEntityID);

        var direction = this.isParentAssociation ? 1 : 0;

        this.entityService.associateEntity(this.associateToParentEntityID, childEntityIDs, direction)
            .then((result) => {
                this.notifyService.endProgress();
            });
    }

    Cancel() {
        if (this.isNewAssociation) {
            var recID = Utils.IdBuilder.splitEntityID(this.associateToParentEntityID).recID;
            var cancelUrl = this.cancelUrl.replace("-1", recID.toString());
            this.$window.location.assign(cancelUrl);
        }
        else {
            this.$window.location.assign(this.cancelUrl);
        }

    }

    Save(isValid) {
        if (!isValid) {
            this.notifyService.notifyError("Correct Errors");
        } else {
            return this.SaveEntity();
        }
    }
}

export class ContactFilesController {
    static $inject = ["$scope", "$sce", "$q", "$window", "notifyService", "contactSharedDataService", "eventService", "entityService", "aclService"];

    contactID: string;
    visibility: number;
    initialized: boolean;
    docsInitialized: boolean;
    locked: boolean;
    canEdit: boolean;

    constructor(private $scope: ng.IScope,
        private $sce: ng.ISCEService,
        $q: ng.IQService,
        private $window: ng.IWindowService,
        private notifyService: NotifyService,
        private sharedData: ContactSharedDataService,
        private eventService: EventService,
        private entityService: EntityService,
        private aclService: AclService) {

        this.contactID = "";
        this.visibility = 1;
        this.initialized = false;
        this.docsInitialized = true;
        this.locked = false;
        this.canEdit = false;

        $scope.$watch(
            () => this.sharedData.contact != null ? this.sharedData.contact.charDataCollection.status.lockIndicator : 1,
            (newValue, oldValue) => {
                this.locked = newValue > 0;
            });

        this.$scope.$watch(() => {
            if (this.contactID == null) {
                return null;
            } else {
                return this.contactID;
            }
        },
            (newValue, oldValue) => {
                if (newValue != null) {
                    this.eventService.on(Consts.Events.WorkflowExecuted + newValue, () => {
                        this.UpdateRecordStatus();
                    });
                }
            });
    }

    Init(contactID: string) {
        this.contactID = contactID;
        this.notifyService.startProgress();

        this.aclService.loadActivityAcls()
            .then((acls) => {
                switch (Consts.CharTypeIDs.user) {
                    case Consts.CharTypeIDs.user:
                        this.canEdit = Utils.AclUtil.hasCreateAccess(acls, Consts.Acl.Activities._Site.Mod2);
                        break;
                }
            });

        this.UpdateRecordStatus();

        this.sharedData.RefreshFiles(this.contactID)
            .then(() => {
                this.initialized = true;
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Contact?") && this.$window.confirm("Are you REALLY SURE you want to delete this Contact?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.contactID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ContactListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Contact");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    RefreshAll(): ng.IPromise<any> {
        return this.RefreshValidation()
            .then(() => {
                this.docsInitialized = false;
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    UpdateRecordStatus() {
        this.entityService.getEntity(this.contactID)
            .then((result) => {
                if (result.charDataCollection != null) {
                    if (result.charDataCollection.status.lockIndicator == 0) {
                        this.locked = false;
                    }
                    else {
                        this.locked = true;
                    }
                }
            });
    }
}

export class ContactFinancialsController extends BaseAssociationController<Models.IContactSearchDoc> {
    static $inject = ["$scope", "$window", "$filter", "$q", "notifyService", "contactService", "entityService", "invoiceService"];

    constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private $filter: ng.IFilterService, private $q: ng.IQService, private notifyService: NotifyService, private contactService: ContactService, private entityService: EntityService, private eventService: EventService) {
        super($scope, $window, $filter, $q, notifyService, entityService, eventService);
    }
}

export class ContactEntityAssociationSearchController extends BaseEntityAssociationController {
    static $inject = ["$scope", "$location", "$filter", "notifyService", "$window", "$q",
        "eventService", "entityService", "entityConfigService", "adminService", "$interval", "searchService", "contactSharedDataService", "aclService"];

    //Search objects
    keywords: string;
    pages: { [key: number]: number };
    templates: { [key: string]: Models.IKeyValuePair<string, number>[] };
    sortDirs: { [key: number]: string };
    sortFields: { [key: number]: string };
    selectedCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
    selectedTemplate: string;
    selectedStatus: string;
    searchStates: { [key: string]: Models.IAdvancedSearchModel };
    templateFacets: Models.IKeyValuePair<string, string>[];
    statusFacets: Models.IKeyValuePair<string, string>[];

    //Associations objects
    sharedData: ContactSharedDataService;
    filterByEntityID: string;
    charTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[];
    selectedRecords: any[];
    associateCharType: Models.IAssociationCharTypeAndTemplateGroupExtended;
    currentCharTypeAndTemplateGroup: Models.IAssociationCharTypeAndTemplateGroupExtended;
    canCreate: boolean = false;
    canEdit: boolean = false;
    currentCharTypeName: string;
    refreshAssociationPanels: boolean;
    initialized: boolean;

    constructor(private $scope: ng.IScope, private $location: ng.ILocationService, private $filter: ng.IFilterService,
        public notifyService: NotifyService, private $window: ng.IWindowService,
        public $q: ng.IQService,
        public eventService: EventService,
        private entityService: EntityService,
        private entityConfigService: EntityConfigService,
        public adminService: AdminService,
        public $interval: ng.IIntervalService,
        private searchService: SearchService,
        private contactSharedDataService: ContactSharedDataService,
        private aclService: AclService) {

        super($scope, notifyService, adminService, $interval, $q, entityService, eventService);

        //Search objects
        this.keywords = "";
        this.pages = {};
        this.templates = {};
        this.sortDirs = {};
        this.sortFields = {};
        this.selectedCharType = null;
        this.selectedTemplate = null;
        this.searchStates = {};
        this.templateFacets = [];
        this.statusFacets = [];

        //Associations objects
        this.sharedData = contactSharedDataService;
        this.filterByEntityID = "";
        this.charTypesAndTemplateGroups = [];
        this.selectedRecords = [];
        this.locked = false;
        this.currentCharTypeAndTemplateGroup = { name: "", createName: "", charTypeID: 0, tgIDs: [], isParentChar: false };
        this.currentCharTypeName = "";
        this.refreshAssociationPanels = false;
        this.initialized = false;

        $scope.$watch(() => this.sharedData.contactStatus != null ? this.sharedData.contactStatus.lockIndicator : 1,
            (newvalue, oldvalue) => {
                this.locked = newvalue > 0;
            });
    }

    public get shouldShowNoSearchResults(): boolean {
        var searchResultCount: number = 0;
        for (var key in this.searchStates) {
            searchResultCount += this.searchStates[key].searchGroups.length;
        }
        return (this.keywords !== "") && (searchResultCount === 0);
    }

    CharTypeChanged() {
        this.selectedTemplate = null;
        this.selectedStatus = null;
        this.BuildSearchStates();
    }

    TemplateChanged() {
        this.selectedStatus = null;
        this.BuildSearchStates();
    }

    StatusChanged() {
        this.BuildSearchStates();
    }

    Init(filterByEntityID: string, charTypeName: string, charTypeID: string, templateID: string) {
        this.filterByEntityID = filterByEntityID;
        this.baseEntityID = filterByEntityID;
        this.currentCharTypeName = charTypeName;

        //Get ACLs for user
        this.entityService.getEntityRecord(filterByEntityID)
            .then((result) => {
                var targetACL = Utils.AclUtil.getDataEntityAcl(result.charTypeID, result.templateGroupID, result.templateID);
                this.canCreate = Utils.AclUtil.hasCreateAccess(this.aclService.acls, targetACL);
                this.canEdit = Utils.AclUtil.hasWriteAccess(this.aclService.acls, targetACL);
            });

        this.LoadTemplateGroups();
        this.sharedData.RefreshContact(filterByEntityID);
        this.sharedData.RefreshContactStatus(filterByEntityID)
            .then(() => {
                this.initialized = true;
            });
    }

    RefreshValidation(): ng.IPromise<any> {
        this.refreshAssociationPanels = true;
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    LoadTemplateGroups() {
        this.notifyService.startProgress();

        //Hardcoded list of valid char types per Joe N.
        //16, 1, 17, 4, 15, and 7
        //We add 2 here as this is the one association v2 page where we want Contacts
        var validCharTypes = [2, 16, 1, 17, 4, 15, 7];
        var tmpCharTypesAndTemplateGroups: Models.IAssociationCharTypeAndTemplateGroupExtended[] = [];

        this.entityConfigService.getRelatedConfigurationCharacteristicTypes(Consts.CharTypeIDs.user)
            .then((results) => {

                _.forEach(results, (result) => {
                    var charName = result.charTypeName;

                    if (charName == "Transaction") {
                        charName = "Deals";
                    }
                    else if (charName == "Work Orders") {
                        charName = "Jobs";
                    }
                    else if (charName == "Property") {
                        charName = "Catalog Items";
                    }
                    else if (charName == "Invoice") {
                        charName = "Accounting";
                    }

                    if (validCharTypes.indexOf(result.charTypeID) > -1) {
                        tmpCharTypesAndTemplateGroups.push({
                            name: charName,
                            createName: charName,
                            charTypeID: result.charTypeID,
                            tgIDs: [1],
                            isParentChar: false
                        });

                        if (this.currentCharTypeName == charName) {
                            this.currentCharTypeAndTemplateGroup = {
                                name: charName,
                                createName: charName,
                                charTypeID: result.charTypeID,
                                tgIDs: [],
                                isParentChar: false
                            }
                        }
                    }
                });
            })
            .finally(() => {
                this.entityConfigService.getRelatedConfigurationParentCharacteristicTypes(Consts.CharTypeIDs.user)
                    .then((results) => {
                        _.forEach(results, (result) => {
                            var charName = result.charTypeName;

                            if (charName == "Transaction") {
                                charName = "Deals";
                            }
                            else if (charName == "Work Orders") {
                                charName = "Jobs";
                            }
                            else if (charName == "Property") {
                                charName = "Catalog Items";
                            }
                            else if (charName == "Invoice") {
                                charName = "Accounting";
                            }

                            var charType = { name: charName, createName: charName, charTypeID: result.charTypeID, tgIDs: [1], isParentChar: true }

                            //Check to see if the array already has reference to this charType.  If so, we just want to flip the isParentChar flag to true
                            //If not, add the new charType

                            var matchingCharTypes = tmpCharTypesAndTemplateGroups.filter(ct => ct.charTypeID == result.charTypeID);

                            if (validCharTypes.indexOf(result.charTypeID) > -1) {
                                if (matchingCharTypes.length > 0) {
                                    var index = tmpCharTypesAndTemplateGroups.indexOf(matchingCharTypes[0]);
                                    tmpCharTypesAndTemplateGroups[index].isParentChar = true;
                                }
                                else {
                                    tmpCharTypesAndTemplateGroups.push(charType);
                                }

                                if (this.currentCharTypeName == charName) {
                                    this.currentCharTypeAndTemplateGroup = {
                                        name: charName,
                                        createName: charName,
                                        charTypeID: result.charTypeID,
                                        tgIDs: [],
                                        isParentChar: true
                                    }
                                }
                            }
                        });
                    })
                    .finally(() => {
                        //Sort the list based on how Joe wants it
                        //Projects, Catalog Items, Deals, Inventory, Jobs, Accounting
                        //Contacts is added here at the beginning as this is the Contacts module
                        var sortList = [2, 16, 1, 4, 17, 15, 7];

                        var sorted = _.sortBy(tmpCharTypesAndTemplateGroups, function (obj) {
                            return _.indexOf(sortList, obj.charTypeID);
                        });

                        var currentCharTypeIndex = _.findIndex(sorted, c => c.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID);

                        this.SortByIndex(sorted, currentCharTypeIndex, 0);

                        sorted.forEach(itm => this.charTypesAndTemplateGroups.push(itm));

                        this.BuildSearchStates();
                        this.notifyService.endProgress();
                    });
            });
    }

    SortByIndex(collection: any[], fromIndex: number, toIndex: number) {
        collection.splice(toIndex, 0, collection.splice(fromIndex, 1)[0]);
    }

    SearchSubmit() {
        this.BuildSearchStates();
    }

    BuildSearchStates() {
        var tempSearchStates: { [key: string]: Models.IAdvancedSearchModel } = {};
        this.searchStates = {};
        var selectedCharTypeID = null;

        if (this.selectedCharType != null) {
            selectedCharTypeID = this.selectedCharType.charTypeID;
        }

        //associations
        var metaDataSearchRequest: Models.IAdvancedSearchModel = {
            charTypeID: selectedCharTypeID,
            searchGroups: [],
            keywords: this.keywords,
            page: this.pages[selectedCharTypeID] || 1,
            rowCount: 10,
            templateGroupIDs: [1, 2],
            template: this.selectedTemplate,
            status: this.selectedStatus,
            sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
            sortField: this.sortFields[selectedCharTypeID] || "",
            relatedEntityID: this.filterByEntityID
        };

        this.searchService.advancedSearch(metaDataSearchRequest)
            .then((res) => {
                this.templateFacets = res.getTemplateFacets();
                this.statusFacets = res.getStatusFacets();
            })
        // end reflective association search

        if (this.selectedCharType != null) {
            var searchState: Models.IAdvancedSearchModel = {
                charTypeID: selectedCharTypeID,
                searchGroups: [],
                keywords: this.keywords,
                page: this.pages[selectedCharTypeID] || 1,
                rowCount: 10,
                templateGroupIDs: [1, 2],
                template: this.selectedTemplate,
                status: this.selectedStatus,
                sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
                sortField: this.sortFields[selectedCharTypeID] || "",
                relatedEntityID: this.filterByEntityID,
                explicitRelationshipsOnly: false
            };
            tempSearchStates[this.selectedCharType.name] = searchState;
        }
        else {
            _.each(this.charTypesAndTemplateGroups, ct => {
                var searchState: Models.IAdvancedSearchModel = {
                    charTypeID: ct.charTypeID,
                    searchGroups: [],
                    keywords: this.keywords,
                    page: this.pages[selectedCharTypeID] || 1,
                    rowCount: 10,
                    templateGroupIDs: [1, 2],
                    template: this.selectedTemplate,
                    status: this.selectedStatus,
                    sortDir: _.parseInt(this.sortDirs[selectedCharTypeID]) || 1,
                    sortField: this.sortFields[selectedCharTypeID] || "",
                    relatedEntityID: this.filterByEntityID,
                    explicitRelationshipsOnly: false
                };

                tempSearchStates[ct.name] = searchState;
            });
        }

		var keys = _.keys(tempSearchStates);
		keys.forEach(k => {
			var searchState = tempSearchStates[k];
			if (searchState.charTypeID == this.currentCharTypeAndTemplateGroup.charTypeID) {
				searchState.filterByEntityID = this.filterByEntityID;
				searchState.keywords = this.filterByEntityID;
				searchState.relatedEntityID = "";
			}
		});

        this.searchStates = tempSearchStates;
    }

    CopySuccessful(newEntityID: string) {
        //copy succeeded, navigate user to new entity
        this.$window.location.assign("/Go/" + newEntityID);
    }

    ClearSearch($event?: ng.IAngularEvent) {
        if ($event != null) {
            $event.preventDefault();
        }
        this.keywords = "";
        this.BuildSearchStates();
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Contact?") && this.$window.confirm("Are you REALLY SURE you want to delete this Contact?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.filterByEntityID)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ContactListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Contact");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    ViewEntity(viewEntityID: string) {
        this.entityService.getEntity(viewEntityID)
            .then((res) => {
                this.selectedEntity = res;
            });
    }
}